import React from 'react'
import BuildItem from '../BuildItem'
import { buildItems } from '../config'
import './style.css'

const BuildItems = ({ onBuildItemSelected, selectedBuildItemType }) => (
  <div className="left-pane-build-items">
    {buildItems.map((item, index) => (
      <BuildItem
        {...item}
        key={index}
        selectedType={selectedBuildItemType}
        onClick={onBuildItemSelected}
      />
    ))}
  </div>
)

export default BuildItems
